import "@/App.css";
import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { AgeGateProvider } from "@/context/AgeGateContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Nav from "@/components/Nav";
import PosterBackground from "@/components/PosterBackground";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Sponsorship from "@/pages/Sponsorship";
import Advertise from "@/pages/Advertise";
import PublicGallery from "@/pages/PublicGallery";
import Dashboard from "@/pages/Dashboard";
import Collection from "@/pages/Collection";
import MapPage from "@/pages/MapPage";
import TimelinePage from "@/pages/TimelinePage";
import ArtistsPage from "@/pages/ArtistsPage";
import WishlistPage from "@/pages/WishlistPage";
import SharePage from "@/pages/SharePage";
import CategoryManager from "@/pages/CategoryManager";
import WalletPage from "@/pages/WalletPage";
import SponsorAdmin from "@/pages/SponsorAdmin";
import AdminAds from "@/pages/AdminAds";

function AppLayout() {
  return (
    <div className="flex flex-col min-h-screen">
      <Nav />
      <main className="flex-1 min-w-0 flex flex-col">
        <div className="flex-1"><Outlet /></div>
        <footer className="border-t border-stroke px-6 lg:px-10 py-5 flex flex-col sm:flex-row items-center justify-between gap-2" data-testid="app-footer">
          <div className="font-mono text-[11px] text-muted-gray">© {new Date().getFullYear()} PosterVault. All rights reserved.</div>
          <div className="font-mono text-[10px] text-muted-gray/70">Poster images & artwork remain © their respective artists and owners.</div>
        </footer>
      </main>
    </div>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <AgeGateProvider>
        <PosterBackground />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/sponsorship" element={<Sponsorship />} />
            <Route path="/advertise" element={<Advertise />} />
            <Route path="/g/:slug" element={<PublicGallery />} />
            <Route
              path="/app"
              element={
                <ProtectedRoute>
                  <AppLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Dashboard />} />
              <Route path="collection" element={<Collection />} />
              <Route path="map" element={<MapPage />} />
              <Route path="timeline" element={<TimelinePage />} />
              <Route path="artists" element={<ArtistsPage />} />
              <Route path="wishlist" element={<WishlistPage />} />
              <Route path="share" element={<SharePage />} />
              <Route path="categories" element={<CategoryManager />} />
              <Route path="wallet" element={<WalletPage />} />
              <Route path="sponsors" element={<SponsorAdmin />} />
              <Route path="ads" element={<AdminAds />} />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" theme="dark" />
        </AgeGateProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
